import React from 'react'
import { Modal } from './Modal'
import { ForgotForm } from '../Form/ForgotForm'

const ForgotModal = () => {
  return (
    <Modal maxWidth={25} header="Forgot password">
      <ForgotForm />
    </Modal>
  )
}

export { ForgotModal }
